(()=>{
if(window.smNapInit)return;window.smNapInit=true;
if(!customElements.get('catalog-complementary-slider'))customElements.define('catalog-complementary-slider',class extends HTMLElement{
 connectedCallback(){
  if(this.dataset.ready)return;this.dataset.ready='1';
  const slider=this.querySelector('.swiper');
  if(!slider||slider.querySelectorAll('.swiper-slide').length<2)return;
  this.sliderInstance=new window.FoxTheme.Carousel(slider,{slidesPerView:1,spaceBetween:10,loop:false,allowTouchMove:true,autoHeight:false,pagination:{el:this.querySelector('.swiper-pagination'),type:'fraction'},navigation:{prevEl:this.querySelector('.swiper-button-prev'),nextEl:this.querySelector('.swiper-button-next')}});
  this.sliderInstance.init();
 }
});
document.addEventListener('click',event=>{
 const link=event.target.closest('[data-catalog-terms]');if(!link)return;
 const terms=document.getElementById('catalog-return-terms');if(terms)terms.open=true;
});
document.addEventListener('change',event=>{
 const select=event.target.closest('[data-catalog-related-variant]');if(!select)return;
 const card=select.closest('[data-catalog-related-card]'),option=select.selectedOptions[0];if(!card||!option)return;
 const price=card.querySelector('[data-catalog-related-price]'),compare=card.querySelector('[data-catalog-related-compare]'),quantity=card.querySelector('[data-catalog-related-quantity]');
 if(price)price.innerHTML=option.dataset.price;
 if(compare){compare.innerHTML=option.dataset.comparePrice||'';compare.hidden=!option.dataset.comparePrice;}
 if(quantity)quantity.value=option.dataset.quantityMin||'1';
});
const enhance=()=>{
 if(!document.querySelector('.sm-nap-scope'))return;
 if(document.documentElement.lang.startsWith('sv'))document.querySelectorAll('.Vtl-StickyAddToCart__ProductPrice .money').forEach(price=>{
  const rate=Number(window.FoxTheme?.settings?.seDisplayRate||0);
  if(rate>0){
   const current=price.textContent.trim();
   if(/SEK/.test(current))return;
   const raw=current.replace(/DKK|kr\.?/g,'').replace(/[\s.]/g,'').replace(',','.');
   const dkk=Number(raw);
   if(Number.isFinite(dkk)&&raw)price.textContent=FoxTheme.Currency.formatMoney(Math.round(dkk*100),FoxTheme.settings.moneyFormat);
   return;
  }
  const currency=window.Shopify?.currency?.active||'DKK';
  const value=price.textContent.replace(/\s*kr\.?\s*$/,' '+currency);
  if(value!==price.textContent)price.textContent=value;
 });
 document.querySelectorAll('.complementary-products .product-card__atc,.sm-story__relatedgrid .product-card__atc').forEach(button=>{
  const label=button.querySelector('.sm-nap-add-label');if(!label)return;
  const preorder=/forudbestil|förbeställ/i.test(label.textContent);
  if(preorder){
   if(label.textContent!==(document.documentElement.lang.startsWith('sv')?'Förbeställ':'Forudbestil'))label.textContent=(document.documentElement.lang.startsWith('sv')?'Förbeställ':'Forudbestil');
   button.dataset.smPreorder='true';
   button.setAttribute('aria-label',(document.documentElement.lang.startsWith('sv')?'Förbeställ':'Forudbestil'));
  }else if(button.hasAttribute('data-sm-preorder')){
   delete button.dataset.smPreorder;
   button.setAttribute('aria-label',label.textContent.trim()||(document.documentElement.lang.startsWith('sv')?'Lägg i varukorgen':'Tilføj til kurv'));
  }
 });

 document.querySelectorAll('.sm-story__rail').forEach(rail=>{
  if(rail.dataset.napRailReady)return;rail.dataset.napRailReady='1';
  const align=()=>{const width=Math.round(rail.clientWidth);if(!width||rail.dataset.napRailWidth===String(width))return;rail.dataset.napRailWidth=String(width);const tile=rail.children[1];if(tile&&window.matchMedia('(max-width:767px)').matches)rail.scrollLeft=tile.offsetLeft-(width-tile.clientWidth)/2;else rail.scrollLeft=0;};
  new ResizeObserver(align).observe(rail);requestAnimationFrame(align);
 });
 document.querySelectorAll('[data-nap-video]').forEach(w=>{
  if(w.dataset.ready)return;w.dataset.ready='1';const v=w.querySelector('video'),b=w.querySelector('button');if(!v||!b)return;
  b.hidden=false;v.controls=false;
  b.addEventListener('click',async()=>{try{await v.play();v.controls=true;w.classList.add('is-playing');}catch{v.controls=true;b.hidden=true;}});
  v.addEventListener('ended',()=>{v.controls=false;w.classList.remove('is-playing');});
 });
 document.querySelectorAll('header .menu-drawer-button,header .search-drawer-button,header .cart-drawer-button').forEach(b=>{
  if(b.querySelector('.sm-nap-navlabel'))return;const span=document.createElement('span');span.className='sm-nap-navlabel';span.textContent=b.matches('.menu-drawer-button')?(document.documentElement.lang.startsWith('sv')?'Meny':'Menu'):b.matches('.search-drawer-button')?(document.documentElement.lang.startsWith('sv')?'Sök':'Søg'):(document.documentElement.lang.startsWith('sv')?'Varukorg':'Kurv');b.append(span);
 });
 document.querySelectorAll('.variant-card[data-variant-card]').forEach(b=>b.setAttribute('aria-pressed',b.classList.contains('is-selected')?'true':'false'));
 const score=document.querySelector('.vtl-pr-totals__score'),count=document.querySelector('.vtl-pr-totals__reviews'),sum=document.querySelector('[data-nap-review-summary]');
 if(sum&&score&&count&&!document.documentElement.lang.startsWith('sv')){const txt=score.textContent.trim()+' / 5 · '+count.textContent.trim();if(sum.textContent!==txt)sum.textContent=txt;}
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',enhance);else enhance();
let pending=false;new MutationObserver(()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;enhance();});}).observe(document.body,{childList:true,subtree:true});
document.addEventListener('variant:changed',enhance);document.addEventListener('shopify:section:load',enhance);
})();


